import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { forkJoin } from 'rxjs';
import { NoticeService } from '../../services/notice.service';

import { ModalService } from '../../services/modal.service';
import { I18nTranslator } from '../../i18n/translate';
import { Notice } from '../../models/notice.model';
import { showErrorMessage } from '../../utils/utils';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';
import { PaginationModule } from 'ngx-bootstrap/pagination';

@Component({
  standalone: true,
  selector: 'machinism-cmp',
  templateUrl: 'machinism.html',
  styleUrls: ['machinism.scss'],
  providers: [NoticeService],
  imports: [CommonModule, RouterLink, RouterLinkActive, RouterOutlet, TranslatePipe, TranslateWithPunctuationPipe, FormsModule, PaginationModule],
})
export class MachinismComponent {
  notices: Notice[] = [];

  constructor(
    private NoticeService: NoticeService,
    private i18nTranslator: I18nTranslator,
    private modal: ModalService,
  ) {
    const obs = this.NoticeService.getNotices();
    forkJoin([obs]).subscribe((data: Array<any>) => {
      const fournisseurs = data[0];
      this.notices = new Array<Notice>();
      for (const fournisseur of fournisseurs) {
        console.warn(fournisseur);
        this.notices.push(fournisseur);
      }
    });
  }

  download(result: string) {
    this.NoticeService.downloadResult(result).subscribe(
      (x) => {
        window.location.assign(x.downloadUrl);
      },
      (error) => {
        const msg = this.i18nTranslator.translate('machininisme.error.telecharger');
        this.handleError(error, msg);
      },
    );
  }

  handleError(error: any, msg: string) {
    if (error.status === 401) {
      showErrorMessage(this.modal, this.i18nTranslator.translate('machininisme.error.unauthorized'));
    } else {
      console.error(error);
      showErrorMessage(this.modal, msg);
    }
  }
}
